import React from "react";
import { ArrowUpRight } from "lucide-react";
import { TEMPLATES } from "../../lib/templates";

const TemplateCard = ({ t, onUse }) => (
  <button type="button" onClick={() => onUse(t)} data-testid={`template-card-${t.id}`}
    className="group text-left flex flex-col rounded-3xl bg-white overflow-hidden ring-1 ring-slate-200/80 shadow-[0_6px_20px_-12px_rgba(15,23,42,0.3)] hover:shadow-[0_14px_34px_-12px_rgba(14,165,233,0.4)] hover:-translate-y-0.5 transition-[box-shadow,transform] duration-300">
    <div className="relative h-36 w-full shrink-0 overflow-hidden">
      <img src={t.cover} alt={t.name} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
      <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-white/85 backdrop-blur text-[11px] font-semibold text-slate-700">{t.category}</span>
    </div>
    <div className="p-5">
      <h3 className="font-display text-lg font-semibold text-slate-900 flex items-center justify-between">{t.name}<ArrowUpRight size={17} className="text-slate-400 group-hover:text-sky-600 transition-colors" /></h3>
      <p className="mt-1 text-sm text-slate-500 leading-relaxed">{t.blurb}</p>
    </div>
  </button>
);

export const TemplateGallery = ({ onUse }) => (
  <section data-testid="template-gallery">
    <h1 className="text-center text-[28px] sm:text-4xl font-medium tracking-tight text-slate-900">Start from a template</h1>
    <p className="text-center text-[15px] text-slate-600 mt-2 mb-10">Pick one to load a ready-made brief into the prompt box, tweak it, then build.</p>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
      {TEMPLATES.map((t) => <TemplateCard key={t.id} t={t} onUse={onUse} />)}
    </div>
  </section>
);

export default TemplateGallery;
